import React from "react";
import { Polygon, Popup } from "react-leaflet";

// EmergencyInfoBC: Order = leave now (red), Alert = be ready (amber)
const STYLES = {
  Order: { color: "#E63946", fillColor: "#E63946", fillOpacity: 0.22, weight: 2 },
  Alert: { color: "#FFB347", fillColor: "#FFB347", fillOpacity: 0.16, weight: 2, dashArray: "6 4" },
};

export default function BcEvacsLayer({ evacs = [] }) {
  return (
    <>
      {evacs
        .filter((e) => e.geometry?.rings?.length)
        .map((e) => (
          <Polygon
            key={e.id}
            positions={e.geometry.rings.map((ring) => ring.map(([lon, lat]) => [lat, lon]))}
            pathOptions={STYLES[e.status] || STYLES.Alert}
          >
            <Popup>
              <div style={{ minWidth: 190 }} data-testid={`bc-evac-popup-${e.id}`}>
                <div style={{ fontSize: 10, fontWeight: 700, color: e.status === "Order" ? "#E63946" : "#FFB347", textTransform: "uppercase", letterSpacing: "0.06em" }}>
                  BC Evacuation {e.status} {e.status === "Order" ? "· LEAVE NOW" : "· BE READY"}
                </div>
                <div style={{ fontWeight: 700, fontSize: 13, margin: "3px 0" }}>{e.zone_name || e.event_name}</div>
                <div style={{ fontSize: 12, lineHeight: 1.55 }}>
                  {e.event_name && e.zone_name && <>{e.event_name}<br /></>}
                  {e.agency && <>Issued by {e.agency}<br /></>}
                  {e.population ? <>~{e.population.toLocaleString()} people affected<br /></> : null}
                  {e.modified_at && <>Updated {new Date(e.modified_at).toLocaleString()}</>}
                </div>
              </div>
            </Popup>
          </Polygon>
        ))}
    </>
  );
}
